<template>
	<div class="cui-login-wrapper">

		<section class="s-content">
			<div v-if="loginMethod =='pwd'" class="animated fadeIn" key="box1">
				<code-login :loginMethod.sync="loginMethod"></code-login>
			</div>
			<div v-else key="box2" class="animated fadeIn">
				<pwd-login :loginMethod.sync="loginMethod"></pwd-login>
			</div>
		</section>

		<footer class="f-copyright">
		  	版权所有：中智薪税技术服务有限公司 &nbsp;京公网安备 11010502042147号 京ICP备07500522号-5
	  	</footer>
  	</div>
</template>

<script>
import { setRem } from '@/util/commen.js'
import codeLogin from './codelogin'
import pwdLogin from './pwdlogin'
import { mapGetters } from 'vuex'

export default {
	name: 'codelogin',

	components: { codeLogin, pwdLogin },

	data() {
		return {
			loginMethod: 'code'
		}
	},

	computed: {
      ...mapGetters([ 'lang' ]),
    },

	created() {
		setRem()
		localStorage.setItem('version', this.$route.meta.version)
	},
	mounted() {

	}
}
</script>

<style lang="scss" scoped>
.cui-login-wrapper {
	position: relative;
	width: 100%;
	height: 100%;
	background: url(../../assets/webImg/login/beijing.png) 0 0 no-repeat;
	background-size: cover;
	overflow: auto;

	.f-copyright {
		position: absolute;
		bottom: 0.15rem;
		width: 100%;
		text-align: center;
		font-size: 0.20rem;
		color: #fff;
	}

	.s-content {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: 5.70rem;
		max-height: 6.60rem;
		margin: auto;
		border-radius: 0.10rem;
		background: #FFFFFF;
		box-shadow: 0px 0px 4px 0px rgba(145,145,145,0.27);
	}
}
</style>

